import React, { Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router';
import Home from '../pages/Home/home';
import ShipmentsPage from '../pages/shipments/shipments-page';
import ExpediteShipmentsPage from '../pages/shipments/expedite-shipments/expedite-shipments-page';
import QuoteManagementPage from '../pages/quote-management/quote-management-page';
import UnderConstructionPage from '../pages/under-constrcution/under-construction-page';
import { useSetCustomerPortalGlobalStorePath } from '../stores/customer-portal-global-store';
import Loader from '../common/loader';
import {
  approvedWeeklySchedulesUrl,
  createDamagesClaimsUrl,
  currentWeekSchedulesUrl,
  damagesClaimsUrl,
  expediteShipments,
  ftpUserDetails,
  ftpUsersUrl,
  invoiceDetails,
  lanesAndLogisticsPlan,
  lanesInLogisticsPlanUrl,
  preAlertsAsnPreviewUrl,
  preAlertsAsnUrl,
  shipmentDetails,
  shipmentManagement,
  weeklyScheduleApprovalRequestUrl
} from '../common/constants/url-constants';
import { ClaimsProvider } from '../stores/damages-claims/claims-store';

const CreateOrder = React.lazy(() => import('../pages/create-order'));
const CreateQuote = React.lazy(() => import('../pages/create-quote'));
const SupportContacts = React.lazy(() => import('../pages/support-contacts'));
const Documents = React.lazy(() => import('../pages/documents'));
const Invoices = React.lazy(() => import('../pages/invoices'));
const ShipmentDetails = React.lazy(
  () => import('../pages/shipments/shipment-details')
);
const DamagesAndClaims = React.lazy(() => import('../pages/damages-claims'));
const CreateClaim = React.lazy(
  () => import('../pages/damages-claims/create-claim')
);
const InvoiceDetailPage = React.lazy(() => import('../pages/invoices/detail'));
const FtpUsers = React.lazy(() => import('../pages/ftp-users'));
const FtpUserDetailPage = React.lazy(() => import('../pages/ftp-users/detail'));
const LanesLogisticsPlan = React.lazy(
  () => import('../pages/lanes-logistics-plan')
);
const CurrentWeekSchedules = React.lazy(
  () => import('../pages/lanes-logistics-plan/current-week-schedules')
);
const WeeklyScheduleApprovalRequest = React.lazy(
  () => import('../pages/lanes-logistics-plan/weekly-schedule-approval-request')
);
const ApprovedWeeklySchedules = React.lazy(
  () => import('../pages/lanes-logistics-plan/approved-weekly-schedules')
);
const LanesInLogisticsPlan = React.lazy(
  () => import('../pages/lanes-logistics-plan/lanes-in-logistics-plan')
);
const PreAlertsAsn = React.lazy(
  () => import('../pages/lanes-logistics-plan/pre-alerts-asn')
);
const AsnPreview = React.lazy(
  () => import('../pages/lanes-logistics-plan/pre-alerts-asn/asn-preview')
);

export default function AppModules() {
  const setIsLoading = useSetCustomerPortalGlobalStorePath(
    store => store.menu.isLoading
  );

  useEffect(() => {
    setIsLoading(false);
  }, [setIsLoading]);

  return (
    <>
      <div>
        <Routes>
          <Route path="/" Component={Home} />
          <Route path="/home" Component={Home} />
          <Route
            path="/ordersquotations/createorder"
            element={
              <Suspense fallback={<Loader />}>
                <CreateOrder />
              </Suspense>
            }
          />
          <Route
            path="/ordersquotations/createquote"
            element={
              <Suspense fallback={<Loader />}>
                <CreateQuote />
              </Suspense>
            }
          />
          <Route
            path="/ordersquotations/quotemanagement"
            Component={QuoteManagementPage}
          />
          <Route path={shipmentManagement} Component={ShipmentsPage} />
          <Route path={expediteShipments} Component={ExpediteShipmentsPage} />
          <Route
            path={shipmentDetails}
            element={
              <Suspense fallback={<Loader />}>
                <ShipmentDetails />
              </Suspense>
            }
          />
          <Route
            path="/supportcontacts"
            element={
              <Suspense fallback={<Loader />}>
                <SupportContacts />
              </Suspense>
            }
          />
          <Route path="/releases" Component={UnderConstructionPage} />
          <Route
            path="/documents"
            element={
              <Suspense fallback={<Loader />}>
                <Documents />
              </Suspense>
            }
          />
          <Route
            path={lanesAndLogisticsPlan}
            element={
              <Suspense fallback={<Loader />}>
                <LanesLogisticsPlan />
              </Suspense>
            }
          />
          <Route
            path={currentWeekSchedulesUrl}
            element={
              <Suspense fallback={<Loader />}>
                <CurrentWeekSchedules />
              </Suspense>
            }
          />
          <Route
            path={weeklyScheduleApprovalRequestUrl}
            element={
              <Suspense fallback={<Loader />}>
                <WeeklyScheduleApprovalRequest />
              </Suspense>
            }
          />
          <Route
            path={approvedWeeklySchedulesUrl}
            element={
              <Suspense fallback={<Loader />}>
                <ApprovedWeeklySchedules />
              </Suspense>
            }
          />
          <Route
            path={lanesInLogisticsPlanUrl}
            element={
              <Suspense fallback={<Loader />}>
                <LanesInLogisticsPlan />
              </Suspense>
            }
          />
          <Route
            path={preAlertsAsnUrl}
            element={
              <Suspense fallback={<Loader />}>
                <PreAlertsAsn />
              </Suspense>
            }
          />
          <Route
            path={preAlertsAsnPreviewUrl}
            element={
              <Suspense fallback={<Loader />}>
                <AsnPreview />
              </Suspense>
            }
          />
          <Route path="/reports" Component={UnderConstructionPage} />
          <Route
            path="/invoices"
            element={
              <Suspense fallback={<Loader />}>
                <Invoices />
              </Suspense>
            }
          />
          <Route
            path={invoiceDetails}
            element={
              <Suspense fallback={<Loader />}>
                <InvoiceDetailPage />
              </Suspense>
            }
          />
          <Route
            path={damagesClaimsUrl}
            element={
              <Suspense fallback={<Loader />}>
                <DamagesAndClaims />
              </Suspense>
            }
          />
          <Route
            path={createDamagesClaimsUrl}
            element={
              <ClaimsProvider>
                <Suspense fallback={<Loader />}>
                  <CreateClaim />
                </Suspense>
              </ClaimsProvider>
            }
          />
          <Route path="/tickets" Component={UnderConstructionPage} />
          <Route
            path={ftpUsersUrl}
            element={
              <Suspense fallback={<Loader />}>
                <FtpUsers />
              </Suspense>
            }
          />
          <Route
            path={ftpUserDetails}
            element={
              <Suspense fallback={<Loader />}>
                <FtpUserDetailPage />
              </Suspense>
            }
          />
          <Route path="/underconstrcution" Component={UnderConstructionPage} />
        </Routes>
      </div>
    </>
  );
}
